const currencyFormatter = new Intl.NumberFormat('en-US', {
    // style: 'currency',
    // currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

export const ArticleCardGridHeader = [
    { field: 'id', headerName: '#', width: 40, headerClassName: 'super-app-theme--header', groupable: false, aggregable: true },
    // { field: 'ledgerID', headerName: 'ID e llogarisë', width: 150, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'barcode', headerName: 'Barkodi', width: 150, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'articleName', headerName: 'Emertimi artikullit', width: 150, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    {
        field: 'jan', headerName: 'Janar', type: 'string', width: 100, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'feb', headerName: 'Shkurt', type: 'string', width: 100, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'mar', headerName: 'Mars', type: 'string', width: 100, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'apr', headerName: 'Prill', type: 'string', width: 100, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'may', headerName: 'Maj', type: 'string', width: 100, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'jun', headerName: 'Qershor', type: 'string', width: 100, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'jul', headerName: 'Korrik', type: 'string', width: 100, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'aug', headerName: 'Gusht', type: 'string', width: 100, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'sep', headerName: 'Shtator', type: 'string', width: 100, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'oct', headerName: 'Tetor', type: 'string', width: 100, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'nov', headerName: 'Nentor', type: 'string', width: 100, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'dec', headerName: 'Dhjetor', type: 'string', width: 100, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'tot', headerName: 'Total', type: 'string', width: 100, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'avg', headerName: 'Cmimi mesatar', type: 'string', width: 100, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'valEu', headerName: 'Vlera në euro', type: 'string', width: 100, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
]

export const TrialBalanceDetailsHeader = [
    { field: 'id', headerName: '#', width: 70, headerClassName: 'super-app-theme--header', groupable: false, aggregable: true },
    { field: 'type', headerName: 'Lloji', width: 70, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'ledgerNameSQ', headerName: 'Llogaria', width: 200, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'comment', headerName: 'Përshkrimi', width: 250, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'date', headerName: 'Data', width: 150, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    {
        field: 'debit', headerName: 'Debi', type: 'string', width: 180, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'credit', headerName: 'Kredi', type: 'string', width: 180, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'progressive', headerName: 'Progresive', type: 'string', width: 180, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
]


//Header per excel

export const sinteticArticleColumns = ["Barcode", "ArticleName", "Janar", "Shkurt", "Mars", "Prill", "Maj", "Qershor", "Korrik", "Gusht", "Shtator", "Tetor", "Nentor", "Dhjetor", "Total", "CmimiMesatar", "VleraNeEuro"];

export const sinteticArticleMappings = {
    Barcode: "Barkodi",
    ArticleName: "Emertimi artikullit",
    Janar: "Janar",
    Shkurt: "Shkurt",
    Mars: "Mars",
    Prill: "Prill",
    Maj: "Maj",
    Qershor: "Qershor",
    Korrik: "Korrik",
    Gusht: "Gusht",
    Shtator: "Shtator",
    Tetor: "Tetor",
    Nentor: "Nentor",
    Dhjetor: "Dhjetor",
    Total: "Total",
    CmimiMesatar: "CmimiMesatar",
    VleraNeEuro: "VleraNeEuro"
};

//detajet e artikullit
export const ArticleDetailsGrid = [
    { field: 'id', headerName: '#', width: 40, headerClassName: 'super-app-theme--header', groupable: false, aggregable: true },
    // { field: 'ledgerID', headerName: 'ID e llogarisë', width: 150, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'barcode', headerName: 'Barkodi', width: 150, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'articleName', headerName: 'Emertimi artikullit', width: 150, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'accountName', headerName: 'Klienti', width: 150, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    {
        field: 'jan', headerName: 'Janar', type: 'string', width: 100, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'feb', headerName: 'Shkurt', type: 'string', width: 100, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'mar', headerName: 'Mars', type: 'string', width: 100, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'apr', headerName: 'Prill', type: 'string', width: 100, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'may', headerName: 'Maj', type: 'string', width: 100, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'jun', headerName: 'Qershor', type: 'string', width: 100, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'jul', headerName: 'Korrik', type: 'string', width: 100, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'aug', headerName: 'Gusht', type: 'string', width: 100, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'sep', headerName: 'Shtator', type: 'string', width: 100, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'oct', headerName: 'Tetor', type: 'string', width: 100, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'nov', headerName: 'Nentor', type: 'string', width: 100, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'dec', headerName: 'Dhjetor', type: 'string', width: 100, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'tot', headerName: 'Total', type: 'string', width: 100, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'avg', headerName: 'Cmimi mesatar', type: 'string', width: 100, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'valEu', headerName: 'Vlera në euro', type: 'string', width: 100, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
]

export const ArticleDetailsColumns = ["Barcode", "ArticleName", "AccountName", "Janar", "Shkurt", "Mars", "Prill", "Maj", "Qershor", "Korrik", "Gusht", "Shtator", "Tetor", "Nentor", "Dhjetor", "Total", "CmimiMesatar", "VleraNeEuro"];

export const ArticleDetailsMappings = {
    Barcode: "Barkodi",
    ArticleName: "Emertimi artikullit",
    AccountName: "Klienti",
    Janar: "Janar",
    Shkurt: "Shkurt",
    Mars: "Mars",
    Prill: "Prill",
    Maj: "Maj",
    Qershor: "Qershor",
    Korrik: "Korrik",
    Gusht: "Gusht",
    Shtator: "Shtator",
    Tetor: "Tetor",
    Nentor: "Nentor",
    Dhjetor: "Dhjetor",
    Total: "Total",
    CmimiMesatar: "CmimiMesatar",
    VleraNeEuro: "VleraNeEuro"
};
